import { useState, useEffect } from "react";
import FormSelect from "../../../../components/Form/FormSelect";
import CheckboxField from "../../../../components/Form/CheckboxField";
import SystemValueForm from "../../../../components/SystemValue/SystemValueForm";

const LanguagePairForm = ({ itemToEdit, onSave, onCancel, languages }) => {
  const [formData, setFormData] = useState({
    source_language_id: "",
    target_language_id: "",
    active_flag: true,
  });
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");

  useEffect(() => {
    if (itemToEdit) {
      setFormData({
        source_language_id: itemToEdit.sourceLanguage?.id || "",
        target_language_id: itemToEdit.targetLanguage?.id || "",
        active_flag: itemToEdit.active_flag,
      });
    } else {
      setFormData({
        source_language_id: "",
        target_language_id: "",
        active_flag: true,
      });
    }
  }, [itemToEdit]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setFormError("");
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setFormError("");

    const currentErrors = {};
    if (!formData.source_language_id)
      currentErrors.source_language_id = "Source Language is required.";
    if (!formData.target_language_id)
      currentErrors.target_language_id = "Target Language is required.";

    if (Object.keys(currentErrors).length > 0) {
      setErrors(currentErrors);
      return;
    }

    if (formData.source_language_id === formData.target_language_id) {
      setFormError("Source and Target languages cannot be the same.");
      return;
    }

    onSave(formData);
  };

  const languageOptions = languages.map((lang) => ({
    value: lang.id,
    label: lang.name,
  }));

  return (
    <SystemValueForm
      title={itemToEdit ? "Edit Language Pair" : "Add Language Pair"}
      onSubmit={handleFormSubmit}
      onCancel={onCancel}
      error={formError}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-4 items-start">
        <FormSelect
          label="Source Language"
          name="source_language_id"
          value={formData.source_language_id}
          onChange={handleChange}
          options={languageOptions}
          error={errors.source_language_id}
          required
        />
        <FormSelect
          label="Target Language"
          name="target_language_id"
          value={formData.target_language_id}
          onChange={handleChange}
          options={languageOptions}
          error={errors.target_language_id}
          required
        />
      </div>
      <CheckboxField
        label="Active"
        name="active_flag"
        checked={formData.active_flag}
        onChange={handleChange}
      />
    </SystemValueForm>
  );
};

export default LanguagePairForm;
